import WorkContentApi from "../apis/WorkContentApi";
import { offlineService } from "./OfflineService";

/**
 * 作業内容サービスクラス
 */
class WorkContentService {
  /**
   * 作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @memberof WorkContentService
   */
  async get(workId) {
    return await new WorkContentApi(this).get(workId);
  }
  /**
   * 間接作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @memberof WorkContentService
   */
  async getIndirect(workId) {
    return await new WorkContentApi(this).getIndirect(workId);
  }
  /**
   * 無負荷作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @memberof WorkContentService
   */
  async getNoload(workId) {
    return await new WorkContentApi(this).getNoload(workId);
  }
  /**
   * 停止ロス作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @memberof WorkContentService
   */
  async getStoploss(workId) {
    return await new WorkContentApi(this).getStoploss(workId);
  }

  /**
   * 直接作業を登録する
   * @param {object} params 作業データ
   * @memberof WorkContentService
   */
  async createDirect(params) {
    try {
      return await new WorkContentApi(this).createDirect(params);
    } catch (error) {
      console.error(error);
      return await offlineService.create(params);
    }
  }
  /**
   * 直接作業を更新する
   * @param {number} workId 作業ID
   * @param {object} params 作業データ
   * @memberof WorkContentService
   */
  async updateDirect(workId, params) {
    return await new WorkContentApi(this).updateDirect(workId, params);
  }

  checkRequired(workContent) {
    const params = [
      "workplaceId",
      "workProcessId",
      "modelNumberId",
      "modelTypeId",
      "startVolume",
    ];
    let errors = {};
    params.forEach((key) => {
      if (!workContent[key]) {
        errors = { ...errors, [key]: "この項目は必須項目です" };
      }
    });
    return errors;
  }
  checkInterruptRequired(workContent, workType) {
    let params = [
      "workplaceId",
      "workProcessId",
      "modelNumberId",
      "modelTypeId",
      "startVolume",
    ];
    if (workType === "indirect") params.push("indirectWorkId");
    if (workType === "noload") params.push("noloadWorkId");
    let errors = {};
    params.forEach((key) => {
      if (!workContent[key]) {
        errors = { ...errors, [key]: "この項目は必須項目です" };
      }
    });
    return errors;
  }
}
export const workContentService = new WorkContentService();
